export const PurchaseTypeDecorator = {
  url() {
    return `signup-hubspot/purchase`;
  },

  query() {
    return {};
  }

};